//#region Imports
import React, { useState, useEffect, useRef, useContext } from 'react';
import { StyleSheet, Platform, SafeAreaView, TouchableOpacity, FlatList, View, useWindowDimensions, Image } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../styles/commonStyles';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useCompany } from '../../../hooks/useCompany';
import CustomButton from '../../../components/CustomButton';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import HRAdminSelectEmployeeScreen from '../HRAdminEmployees/HRAdminSelectEmployeeScreen';
import HRAdminEmplLeaveAnalysisScreen from '../HRAdminEmployees/HRAdminEmplLeaveAnalysisScreen';
import HRAdminEmployeeRates from '../HRAdminEmployees/HRAdminEmployeeRates';
import HRAdminEditEmployeeScreen from '../HRAdminEmployees/CreateEmployee/HRAdminEditEmployeeScreen';
import { DEFAULTPROFILE } from '../../../img/DefaultProfile';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { HRAdminCompanyContext } from '../../../context/HRAdminCompanyContext';
import HRAdminEmployeeWizard from '../HRAdminEmployees/CreateEmployee/HRAdminEmployeeWizard';
import RoleGuard from '../../../components/RoleGuard';
import useRole from '../../../hooks/userRole';
import { TASKS, TASK_OPTIONS } from '../../../constants/Tasks';
import { useTranslation } from 'react-i18next';
import HRAdminSalaryReviews from '../HRAdminEmployees/HRAdminSalaryReviews';
import HRAdminEmpAlerts from '../HRAdminEmployees/HRAdminEmpAlerts';
import HRAdminAcademicQualifications from '../HRAdminEmployees/HRAdminAcademicQualifications';
import HRAdminAdditionalQualifications from '../HRAdminEmployees/HRAdminAdditionalQualifications';
import HRAdminEmplSpecialDocuments from '../HRAdminEmployees/HRAdminEmplSpecialDocuments';
import HRAdminEmplExitProcess from '../HRAdminEmployees/HRAdminEmplExitProcess';
import HRAdminEmplWorkflows from '../HRAdminEmployees/HRAdminEmplWorkflows';
import HRAdminEmplReportsTo from '../HRAdminEmployees/HRAdminEmplReportsTo';
import HRAdminEmplAuthorizations from '../HRAdminEmployees/CreateEmployee/HRAdminEmplAuthorizations';
import HRAdminAdvancedSettings from '../HRAdminEmployees/AdvancedSettings/HRAdminAdvancedSettings';
import MyTrainingsScreen from '../../SelfService/Trainings/MyTrainingsScreen';
import { useTraining } from '../../../hooks/useTraining';
import HRAdminTrainingDetailsScreen from '../HRAdminTrainings/HRAdminTrainingDetailsScreen';
import HRAdminEmplInventory from '../HRAdminEmployees/HRAdminEmplInventory';
import HRAdminEmplProBodies from '../HRAdminEmployees/HRAdminEmplProBodies';


const HRAdminPageEmployees = () => {

    //#region Const Definitions and UseRef and UseState
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions();
    const { isAdmin } = useRole();
    //* state for Select Employee screen
    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);

    const [locationOptions, setLocationOptions] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);

    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);

    const [seniorityLevelOptions, setSeniorityLevelOptions] = useState([]);
    const [selectedSeniorityLevels, setSelectedSeniorityLevels] = useState([]);

    const [employmentTypeOptions, setEmploymentTypeOptions] = useState([]);
    const [selectedEmploymentTypes, setSelectedEmploymentTypes] = useState([]);

    const [jobTitleOptions, setJobTitleOptions] = useState([]);
    const [selectedJobTitles, setSelectedJobTitles] = useState([]);

    const statusOptions = [{ "label": "All", "value": "All" }, { "label": "Active", "value": "Active" }, { "label": "Inactive", "value": "Inactive" }];
    const [selectAllInactive, setSelectAllInactive] = useState('All');

    const [employees, setEmployees] = useState([]);
    const [searchQuery, setSearchQuery] = useState(undefined);

    const { selectedCompany, setSelectedCompany, selectedEmployee, setSelectedEmployee, companyOptions, setCompanyOption, selectedCompanyCode, setSelectedCompanyCode } = useContext(HRAdminCompanyContext);
    const { getCompanies } = useCompany();
    const [selectedCompanyChanged, setSelectedCompanyChanged] = useState(false);

    //* state for current screen
    const [isLoading, setIsLoading] = useState(false);
    const [showSelectEmployeeScreen, setShowSelectEmployeeScreen] = useState(1);
    const [showNewEmployeeScreen, setShowNewEmployeeScreen] = useState(0);
    const [showEditEmployeeScreen, setShowEditEmployeeScreen] = useState(0);
    const [showEmployeeAuditTrailScreen, setShowEmployeeAuditTrailScreen] = useState(0);
    const [showEmployeeWorkflowsScreen, setShowEmployeeWorkflowsScreen] = useState(0);
    const [showEmployeeReportsToScreen, setShowEmployeeReportsToScreen] = useState(0);
    const [showEmployeeSalaryReviewsScreen, setShowEmployeeSalaryReviewsScreen] = useState(0);
    const [showEmployeeLeaveAnalysisScreen, setShowEmployeeLeaveAnalysisScreen] = useState(0);
    const [showEmployeeTrainings, setShowEmployeeTrainings] = useState(0);
    const [showAcademicQualifications, setShowAcademicQualifications] = useState(0);
    const [showAdditionalQualifications, setShowAdditionaQualifications] = useState(0);
    const [showEmployeeRates, setShowEmployeeRates] = useState(0);
    const [showSpecialDocuments, setShowSpecialDocuments] = useState(0);
    const [showEmployeeAuth, setShowEmployeeAuth] = useState(0);
    const [showExitProcess, setShowExitProcess] = useState(0);
    const [showEmplAlerts, setShowEmplAlerts] = useState(0);
    const [showAdvancedSettings, setShowAdvancedSettings] = useState(0);
    const [showProfessionalBodies, setShowProfessionalBodies] = useState(0);
    const [showInventory, setShowInventory] = useState(0);

    const buttonTable = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
    const { user, clientApi } = useAuthContext();

    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const common = createCommonStyles(colors);
    const { account } = useAccountContext();
    const flatListRef = useRef(null);

    /* for employee trainings page */
    const { loadUserTrainings, loadTrainingFromUI, loadTrainingHelpers } = useTraining();

    const [showMyTrainingsScreen, setShowMyTrainingsScreen] = useState(1);
    const [showMyTrainingsDetailsScreen, setShowMyTrainingsDetailsScreen] = useState(0);
    const [selectedTraining, setSelectedTraining] = useState({});
    const [trnData, setTRNData] = useState([]);

    const [employeeTrainingsList, setEmployeeTrainingsList] = useState([]);
    const [trnUI, setTRNUI] = useState(null);
    const [trnInfo, setTRNInfo] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);

    const [ldNeed, setLDNeed] = useState([]);
    const [ldMethod, setLDMethod] = useState([]);
    const [trnProvider, setTRNProvider] = useState([]);

    const selectMyTrainingsScreen = () => {
        setShowMyTrainingsScreen(1);
        setShowMyTrainingsDetailsScreen(0);
    };

    const selectMyTrainingsDetailsScreen = () => {
        setShowMyTrainingsScreen(0);
        setShowMyTrainingsDetailsScreen(1);
    };

    const loadTSHelper = () => {
        loadTrainingHelpers()
            .then((userData) => {
                setLDNeed(userData.ldNeed);
                setLDMethod(userData.ldMethod);
                setTRNProvider(userData.trainingProvider);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const loadEmployeeTRN = () => {
        if (selectedEmployee?.employeeID) {
            loadUserTrainings(selectedEmployee.employeeID)
                .then((userData) => {
                    setEmployeeTrainingsList(userData);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const loadTRNDetails = () => {
        if (trnUI !== null) {
            loadTrainingFromUI(trnUI)
                .then((userData) => {
                    const trainingDetails = Array.isArray(userData) ? userData[0] : userData;

                    setIsEdit(trainingDetails.accepted || !trainingDetails.userEditable ? false : true);
                    setIsUserEditable(trainingDetails.accepted ? true : trainingDetails.userEditable);

                    setTRNInfo(userData);
                    setSelectedTraining(trainingDetails);
                    setTRNData(Array.isArray(userData) ? userData : [userData]);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };


    //#region Screen navigation 
    // * To avoid duplicate code hide all and enable one
    const hideAllScreens = () => {
        setShowSelectEmployeeScreen(0);
        setShowNewEmployeeScreen(0);
        setShowEditEmployeeScreen(0);
        setShowEmployeeAuditTrailScreen(0);
        setShowEmployeeWorkflowsScreen(0);
        setShowEmployeeReportsToScreen(0);
        setShowEmployeeSalaryReviewsScreen(0);
        setShowEmployeeLeaveAnalysisScreen(0);
        setShowAcademicQualifications(0);
        setShowAdditionaQualifications(0);
        setShowEmployeeRates(0);
        setShowSpecialDocuments(0);
        setShowExitProcess(0);
        setShowEmployeeAuth(0);
        setShowEmplAlerts(0);
        setShowAdvancedSettings(0);
        setShowEmployeeTrainings(0);
        setShowProfessionalBodies(0);
        setShowInventory(0);
    };
    const pressedOnSelectEmployee = (index) => {
        hideAllScreens();
        setShowSelectEmployeeScreen(1);
        scrollToTab(index);
    };

    const pressedOnNewEmployee = (index) => {
        hideAllScreens();
        setShowNewEmployeeScreen(1);
        scrollToTab(index);
    };

    const pressedOnEditEmployee = (index) => {
        hideAllScreens();
        setShowEditEmployeeScreen(1);
        scrollToTab(index);
    };

    const pressedOnEmployeeAuditTrail = (index) => {
        hideAllScreens();
        setShowEmployeeAuditTrailScreen(1);
        scrollToTab(index);
    };

    const pressedOnEmployeeWorkflowsReportsTo = (index) => {
        hideAllScreens();
        setShowEmployeeWorkflowsScreen(1);
        scrollToTab(index);
    };

    const pressedOnEmployeeReportsTo = (index) => {
        hideAllScreens();
        setShowEmployeeReportsToScreen(1);
        scrollToTab(index);
    };

    const pressedOnEmployeeSalaryReviews = (index) => {
        hideAllScreens();
        setShowEmployeeSalaryReviewsScreen(1);
        scrollToTab(index);
    };

    const pressedOnEmployeeLeaveAnalysis = (index) => {
        hideAllScreens();
        setShowEmployeeLeaveAnalysisScreen(1);
        scrollToTab(index);
    };

    const pressedOnEmployeeTrainings = (index) => {
        hideAllScreens();
        setShowEmployeeTrainings(1);
        scrollToTab(index);
    };

    const pressedOnAcademicQualifications = (index) => {
        hideAllScreens();
        setShowAcademicQualifications(1);
        scrollToTab(index);
    };

    const pressedOnAdditionalQualifications = (index) => {
        hideAllScreens();
        setShowAdditionaQualifications(1);
        scrollToTab(index);
    };
    const pressedOnEmployeeRates = (index) => {
        hideAllScreens();
        setShowEmployeeRates(1);
        scrollToTab(index);
    };

    const pressedOnSpecialDocuments = (index) => {
        hideAllScreens();
        setShowSpecialDocuments(1);
        scrollToTab(index);
    };

    const pressedOnExitProcess = (index) => {
        hideAllScreens();
        setShowExitProcess(1);
        scrollToTab(index);
    };

    const pressedOnEmplAlerts = (index) => {
        hideAllScreens();
        setShowEmplAlerts(1);
        scrollToTab(index);
    };

    const pressedOnAdvancedSettings = (index) => {
        hideAllScreens();
        setShowAdvancedSettings(1);
        scrollToTab(index);
    };

    const pressedOnEmployeeAuth = (index) => {
        hideAllScreens();
        setShowEmployeeAuth(1);
        setShowProfessionalBodies(0);
        scrollToTab(index);
    };

    const pressedOnProfessionalBodies = (index) => {
        hideAllScreens();
        setShowProfessionalBodies(1);
        scrollToTab(index);
    };

    const pressedOnInventory = (index) => {
        hideAllScreens();
        setShowInventory(1);
        scrollToTab(index);
    };
    //#endregion

    const changeSelectedEmployee = (selectedEmployee) => {
        setSelectedEmployee(selectedEmployee)
    };

    //* change state for Select Employee screen
    const changeBranchOptions = (branchOptions) => {
        setBranchOptions(branchOptions)
    };
    const changeSelectedBranches = (selectedBranches) => {
        setSelectedBranches(selectedBranches)
    };

    const changeLocationOptions = (locationOptions) => {
        setLocationOptions(locationOptions)
    };
    const changeSelectedLocations = (selectedLocations) => {
        setSelectedLocations(selectedLocations)
    };

    const changeDepartmentOptions = (departmentOptions) => {
        setDepartmentOptions(departmentOptions)
    };
    const changeSelectedDepartments = (selectedDepartments) => {
        setSelectedDepartments(selectedDepartments)
    };

    const changeSeniorityLevelOptions = (seniorityLevelOptions) => {
        setSeniorityLevelOptions(seniorityLevelOptions)
    };
    const changeSelectedSeniorityLevels = (selectedSeniorityLevels) => {
        setSelectedSeniorityLevels(selectedSeniorityLevels)
    };

    const changeEmploymentTypeOptions = (employmentTypeOptions) => {
        setEmploymentTypeOptions(employmentTypeOptions)
    };
    const changeSelectedEmploymentTypes = (selectedEmploymentTypes) => {
        setSelectedEmploymentTypes(selectedEmploymentTypes)
    };

    const changeJobTitleOptions = (jobTitleOptions) => {
        setJobTitleOptions(jobTitleOptions)
    };
    const changeSelectedJobTitles = (selectedJobTitles) => {
        setSelectedJobTitles(selectedJobTitles)
    };

    const changeEmployees = (employees) => {
        setEmployees(employees)
    };
    const changeSearchQuery = (searchQuery) => {
        setSearchQuery(searchQuery)
    };

    const changeSelectedCompanyChanged = (changed) => {
        setSelectedCompanyChanged(changed)
    };

    //#endregion

    //#region UseEffect
    const scrollToTab = (index) => {
        flatListRef.current?.scrollToIndex({
            index,
            animated: true,
            viewPosition: 0.5,
        });
    };

    useEffect(() => {
        setSelectedCompanyChanged(true);
    }, [selectedCompany]);

    // show Edit Employee screen when employee is selected
    useEffect(() => {
        if (!showNewEmployeeScreen) {
            if (selectedEmployee) {
                pressedOnEditEmployee(0);
            } else {
                pressedOnSelectEmployee(0);
            }
        };
        // * Remember on refresh 
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            try {
                localStorage.setItem(
                    "selectedEmployee",
                    JSON.stringify(selectedEmployee)
                );
                localStorage.setItem(
                    "selectedCompanyContext",
                    JSON.stringify(selectedCompany)
                );
                localStorage.setItem("isRefresh", "true");
                localStorage.setItem("lastVisitedScreen", "HRAdminPageEmployees");
            } catch (error) {
                console.log(error.message);
            }
        };
        if (Platform.OS === "web") {
            window.addEventListener("beforeunload", handleBeforeUnload);
            return () => {
                window.removeEventListener("beforeunload", handleBeforeUnload);
            };
        }
    }, [selectedEmployee, showNewEmployeeScreen]);

    /* use effects for trainings screen */
    useEffect(() => {
        loadTSHelper();
    }, []);

    useEffect(() => {
        if (showEmployeeTrainings && selectedEmployee?.employeeID) {
            loadEmployeeTRN();
            setShowMyTrainingsScreen(1);
            setShowMyTrainingsDetailsScreen(0);
        }
    }, [showEmployeeTrainings, selectedEmployee]);

    useEffect(() => {
        if (trnUI !== null) {
            loadTRNDetails();
        }
    }, [trnUI]);

    //* if refreshed, get data from session storage,
    //* to show same page as before refresh
    const checkIfRefreshed = async () => {
        try {
            let isRefresh = localStorage.getItem("isRefresh");
            if (isRefresh === "true") {
                if (localStorage.getItem("selectedEmployee") !== undefined)
                    setSelectedEmployee(JSON.parse(localStorage.getItem("selectedEmployee")));
                if (localStorage.getItem("selectedCompanyContext") !== undefined && selectedCompany === null) {
                    console.log("Refreshing selected company context from localStorage");
                    setSelectedCompany(JSON.parse(localStorage.getItem("selectedCompanyContext")));
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    // //* handles refresh in web
    useEffect(() => {
        if (Platform.OS === 'web') {
            checkIfRefreshed();
        };
        // * Check Company options here as well if empty load from Employee Tab
        // * This is done to avoid the need to click on Company
        if (!companyOptions || companyOptions.length === 0) {
            getCompanies().then((companies) => setCompanyOption(companies)).catch(console.error);
        }
        setIsLoading(false);
    }, []);


    //#endregion

    if (isLoading === true) return null;
    return (
        <SafeAreaView style={styles.main}>
            {/* first row tabs */}
            <View style={styles.mainSubTabs}>
                <CustomButton
                    onPress={() => {
                        pressedOnSelectEmployee();
                    }}
                    imageBeforeText={selectedEmployee ? selectedEmployee?.photograph ? selectedEmployee?.photograph : DEFAULTPROFILE : undefined}
                    text={selectedEmployee ? selectedEmployee.name : t('navigate:selectEmployee')}
                    iconNameAfterText='search'
                    show={showSelectEmployeeScreen ? 'EMPLOYEES_HOME_SELECTED' : 'EMPLOYEES_HOME'}
                    type={showSelectEmployeeScreen ? 'EMPLOYEES_HOME_SELECTED' : 'EMPLOYEES_HOME'}
                    textTop='0'
                    sz={Platform.OS !== 'web' ? 20 : 25}
                />

                <CustomButton
                    onPress={() => {
                        pressedOnNewEmployee();
                    }}
                    text={t('navigate:newEmployee')}
                    iconName='logo-buffer'
                    show={showNewEmployeeScreen ? 'HOME_SELECTED' : 'HOME'}
                    type={showNewEmployeeScreen ? 'HOME_SELECTED' : 'HOME'}
                    isGradient
                    textTop='0'
                    sz={Platform.OS !== 'web' ? 20 : 25}
                />
            </View>
            <SafeAreaView style={common.divider} />
            {/* second row tabs */}
            {selectedEmployee &&
                <View>
                    <FlatList
                        ref={flatListRef}
                        onScrollToIndexFailed={(info) => {
                            flatListRef.current?.scrollToOffset({
                                offset: info.averageItemLength * info.index,
                                animated: true,
                            });
                        }}
                        horizontal
                        showsHorizontalScrollIndicator={true}
                        directionalLockEnabled={true}
                        alwaysBounceVertical={false}
                        data={buttonTable}
                        contentContainerStyle={{
                            alignSelf: 'flex-start',
                            marginBottom: '1%',
                        }}
                        showsVerticalScrollIndicator={true} //shows horizontal scroll bar on web 
                        renderItem={({ index }) => {
                            return (
                                <SafeAreaView>
                                    {index == 0 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.EMPLEDIT} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnEditEmployee(0);
                                                }}
                                                text={t('navigate:editEmployee')}
                                                iconName='logo-buffer'
                                                show={showEditEmployeeScreen ? 'HOME_SELECTED' : 'HOME'}
                                                type={showEditEmployeeScreen ? 'HOME_SELECTED' : 'HOME'}
                                                textTop='0'
                                                isGradient={showEditEmployeeScreen ? true : false}
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 1 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.LEAVEANALYSIS} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnEmployeeLeaveAnalysis(1);
                                                }}
                                                text={'Leave Analysis'}
                                                iconName='analytics-outline'
                                                show={showEmployeeLeaveAnalysisScreen ? 'HOME_SELECTED' : 'HOME'}
                                                type={showEmployeeLeaveAnalysisScreen ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showEmployeeLeaveAnalysisScreen ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 2 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.ACADEMIC} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnEmployeeTrainings(2);
                                                }}
                                                text={t('navigate:hrAdminTrainings')}
                                                iconName='file-tray-full-outline'
                                                show={showEmployeeTrainings ? 'HOME_SELECTED' : 'HOME'}
                                                type={showEmployeeTrainings ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showEmployeeTrainings ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 3 &&
                                        <RoleGuard task={TASKS.EMPLALERTS} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnEmplAlerts(3);
                                                }}
                                                text={t('navigate:emplAlerts')}
                                                iconName='alert-outline'
                                                show={showEmplAlerts ? 'HOME_SELECTED' : 'HOME'}
                                                type={showEmplAlerts ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showEmplAlerts ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 4 &&
                                        <CustomButton
                                            onPress={() => {
                                                pressedOnProfessionalBodies(4);
                                            }}
                                            text={'Professional Bodies'}
                                            iconName='briefcase-outline'
                                            show={showProfessionalBodies ? 'HOME_SELECTED' : 'HOME'}
                                            type={showProfessionalBodies ? 'HOME_SELECTED' : 'HOME'}
                                            isGradient={showProfessionalBodies ? true : false}
                                            textTop='0'
                                            sz={Platform.OS !== 'web' ? 20 : 25}
                                        />
                                    }

                                    {index == 5 &&
                                        <CustomButton
                                            onPress={() => {
                                                pressedOnInventory(5);
                                            }}
                                            text={'Inventory'}
                                            iconName='cube-outline'
                                            show={showInventory ? 'HOME_SELECTED' : 'HOME'}
                                            type={showInventory ? 'HOME_SELECTED' : 'HOME'}
                                            isGradient={showInventory ? true : false}
                                            textTop='0'
                                            sz={Platform.OS !== 'web' ? 20 : 25}
                                        />
                                    }

                                    {index == 6 &&
                                        <RoleGuard task={TASKS.EMPLMAINTENANCE} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnEmployeeRates(6);
                                                }}
                                                text={t('navigate:employeeRates')}
                                                iconName='pricetag-outline'
                                                show={showEmployeeRates ? 'HOME_SELECTED' : 'HOME'}
                                                type={showEmployeeRates ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showEmployeeRates ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 7 && isAdmin &&
                                        <CustomButton
                                            onPress={() => {
                                                pressedOnEmployeeWorkflowsReportsTo(7);
                                            }}
                                            text={t('navigate:workflows')}
                                            iconName='git-network-outline'
                                            show={showEmployeeWorkflowsScreen ? 'HOME_SELECTED' : 'HOME'}
                                            type={showEmployeeWorkflowsScreen ? 'HOME_SELECTED' : 'HOME'}
                                            isGradient={showEmployeeWorkflowsScreen ? true : false}
                                            textTop='0'
                                            sz={Platform.OS !== 'web' ? 20 : 25}
                                        />
                                    }

                                    {index == 8 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.REPORTSTO} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnEmployeeReportsTo(8);
                                                }}
                                                text={t('navigate:reportsTo')}
                                                iconName='reader-outline'
                                                show={showEmployeeReportsToScreen ? 'HOME_SELECTED' : 'HOME'}
                                                type={showEmployeeReportsToScreen ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showEmployeeReportsToScreen ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 9 && isAdmin &&
                                        <CustomButton
                                            onPress={() => {
                                                pressedOnEmployeeAuth(9);
                                            }}
                                            text={t('navigate:emplAuth')}
                                            iconName='key-outline'
                                            show={showEmployeeAuth ? 'HOME_SELECTED' : 'HOME'}
                                            type={showEmployeeAuth ? 'HOME_SELECTED' : 'HOME'}
                                            isGradient={showEmployeeAuth ? true : false}
                                            textTop='0'
                                            sz={Platform.OS !== 'web' ? 20 : 25}
                                        />
                                    }

                                    {index == 10 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.SALARYREVIEWS} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnEmployeeSalaryReviews(10);
                                                }}
                                                text={t('navigate:salaryReviews')}
                                                iconName='cash-outline'
                                                show={showEmployeeSalaryReviewsScreen ? 'HOME_SELECTED' : 'HOME'}
                                                type={showEmployeeSalaryReviewsScreen ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showEmployeeSalaryReviewsScreen ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 11 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.ACADEMIC} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnAcademicQualifications(11);
                                                }}
                                                text={t('navigate:academicQual')}
                                                iconName='school-outline'
                                                show={showAcademicQualifications ? 'HOME_SELECTED' : 'HOME'}
                                                type={showAcademicQualifications ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showAcademicQualifications ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 12 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.ADDITIONAL} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnAdditionalQualifications(12);
                                                }}
                                                text={t('navigate:additionalQual')}
                                                iconName='document-attach-outline'
                                                show={showAdditionalQualifications ? 'HOME_SELECTED' : 'HOME'}
                                                type={showAdditionalQualifications ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showAdditionalQualifications ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 13 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.SPECIALDOC} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnSpecialDocuments(13);
                                                }}
                                                text={t('navigate:specialDoc')}
                                                iconName='document-outline'
                                                show={showSpecialDocuments ? 'HOME_SELECTED' : 'HOME'}
                                                type={showSpecialDocuments ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showSpecialDocuments ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 14 &&
                                        <RoleGuard parentTask={TASKS.EMPLOYEE} task={TASK_OPTIONS.EXIT} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnExitProcess(14);
                                                }}
                                                text={t('navigate:exitProcess')}
                                                iconName='exit-outline'
                                                show={showExitProcess ? 'HOME_SELECTED' : 'HOME'}
                                                type={showExitProcess ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showExitProcess ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 15 &&
                                        <RoleGuard task={TASKS.EMPLOYEE} table='hr' requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    pressedOnAdvancedSettings(15);
                                                }}
                                                text={t('navigate:advSettings')}
                                                iconName='cog-outline'
                                                show={showAdvancedSettings ? 'HOME_SELECTED' : 'HOME'}
                                                type={showAdvancedSettings ? 'HOME_SELECTED' : 'HOME'}
                                                isGradient={showAdvancedSettings ? true : false}
                                                textTop='0'
                                                sz={Platform.OS !== 'web' ? 20 : 25}
                                            />
                                        </RoleGuard>
                                    }

                                    {index == 16 && isAdmin &&
                                        <CustomButton
                                            onPress={() => {
                                                pressedOnEmployeeAuditTrail(16);
                                            }}
                                            text={'Audit-Trail'}
                                            iconName='hourglass-outline'
                                            show={showEmployeeAuditTrailScreen ? 'HOME_SELECTED' : 'HOME'}
                                            type={showEmployeeAuditTrailScreen ? 'HOME_SELECTED' : 'HOME'}
                                            isGradient={showEmployeeAuditTrailScreen ? true : false}
                                            textTop='0'
                                            sz={Platform.OS !== 'web' ? 20 : 25}
                                        />
                                    }

                                </SafeAreaView>
                            );
                        }}

                        keyExtractor={item => `${item}`}
                    />
                </View>
            }

            {/* Views to show depending on Flatlist Selection */}
            {showSelectEmployeeScreen ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:selectEmployee')}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminSelectEmployeeScreen
                            selectedCompany={selectedCompany}
                            selectedCompanyChanged={selectedCompanyChanged}
                            setSelectedCompanyChanged={changeSelectedCompanyChanged}
                            selectedEmployee={selectedEmployee}
                            setSelectedEmployee={changeSelectedEmployee}
                            branchOptions={branchOptions}
                            setBranchOptions={changeBranchOptions}
                            selectedBranches={selectedBranches}
                            setSelectedBranches={changeSelectedBranches}
                            locationOptions={locationOptions}
                            setLocationOptions={changeLocationOptions}
                            selectedLocations={selectedLocations}
                            setSelectedLocations={changeSelectedLocations}
                            departmentOptions={departmentOptions}
                            setDepartmentOptions={changeDepartmentOptions}
                            selectedDepartments={selectedDepartments}
                            setSelectedDepartments={changeSelectedDepartments}
                            seniorityLevelOptions={seniorityLevelOptions}
                            setSeniorityLevelOptions={changeSeniorityLevelOptions}
                            selectedSeniorityLevels={selectedSeniorityLevels}
                            setSelectedSeniorityLevels={changeSelectedSeniorityLevels}
                            employmentTypeOptions={employmentTypeOptions}
                            setEmploymentTypeOptions={changeEmploymentTypeOptions}
                            selectedEmploymentTypes={selectedEmploymentTypes}
                            setSelectedEmploymentTypes={changeSelectedEmploymentTypes}
                            jobTitleOptions={jobTitleOptions}
                            setJobTitleOptions={changeJobTitleOptions}
                            selectedJobTitles={selectedJobTitles}
                            setSelectedJobTitles={changeSelectedJobTitles}
                            selectAllInactive={selectAllInactive}
                            setSelectAllInactive={setSelectAllInactive}
                            statusOptions={statusOptions}
                            employees={employees}
                            setEmployees={changeEmployees}
                            searchQuery={searchQuery}
                            setSearchQuery={changeSearchQuery}
                            selectedCompanyCode={selectedCompanyCode}
                            companyOptions={companyOptions}
                            setSelectedCompanyCode={setSelectedCompanyCode}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showNewEmployeeScreen ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:newEmployee')}
                        type='MINORTITLE'
                    />
                    <HRAdminEmployeeWizard
                        pressedOnSelectEmployee={pressedOnSelectEmployee} />
                </SafeAreaView>
                : <></>
            }

            {showEditEmployeeScreen ?
                <SafeAreaView style={[styles.main]}>
                    <SafeAreaView style={[styles.row]}>
                        <CustomLabel
                            value={t('navigate:editEmployee')}
                            type='MINORTITLE'
                        />
                    </SafeAreaView>
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEditEmployeeScreen
                            selectedEmployee={selectedEmployee ?? JSON.parse(localStorage.getItem("selectedEmployee"))}
                            selectedCompany={selectedCompany}
                            pressedOnSelectEmployee={pressedOnSelectEmployee}
                            isEdit={true}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showEmployeeAuditTrailScreen ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={'Audit-Trail'}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <CustomLabel
                            value='COMING SOON!'
                            type='COMING_SOON'
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showEmployeeWorkflowsScreen ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={`${t('navigate:workflows')}`}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmplWorkflows
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showEmployeeReportsToScreen ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={`${t('navigate:reportsTo')}`}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmplReportsTo
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showEmployeeAuth ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={`${t('navigate:emplAuth')}`}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmplAuthorizations
                            employee={selectedEmployee}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showEmployeeSalaryReviewsScreen ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:salaryReviews')}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminSalaryReviews
                            selectedCompany={selectedCompany}
                            selectedEmployee={selectedEmployee}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showEmployeeLeaveAnalysisScreen ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:leaveAnalysis')}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmplLeaveAnalysisScreen
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showEmployeeTrainings ? (
                <SafeAreaView style={[styles.main]}>
                    <SafeAreaView style={[styles.subMain]}>
                        {showMyTrainingsScreen ? (
                            <MyTrainingsScreen
                                userTrainings={employeeTrainingsList}
                                setTRNUI={setTRNUI}
                                setIsNew={setIsNew}
                                selectMyTrainingsDetailsScreen={selectMyTrainingsDetailsScreen}
                                isAdmin={true}
                            />
                        ) : (
                            <></>
                        )}

                        {showMyTrainingsDetailsScreen && selectedTraining?.trnUI ? (
                            <SafeAreaView style={[styles.main]}>
                                <SafeAreaView style={{ flexDirection: 'row' }}>
                                    <TouchableOpacity onPress={() => { selectMyTrainingsScreen(); }} style={styles.backButton}>
                                        <Ionicons name="arrow-back" size={30} color="black" />
                                    </TouchableOpacity>
                                    <CustomLabel
                                        value={t("navigate:trnDetails") + ' - ' + (selectedTraining.title ? selectedTraining.title : selectedTraining.courseName ? selectedTraining.courseName : "")}
                                        type="MINORTITLE"
                                    />
                                </SafeAreaView>

                                <SafeAreaView style={[styles.subMain]}>
                                    <HRAdminTrainingDetailsScreen
                                        pressedOnTrainingDetails={selectMyTrainingsDetailsScreen}
                                        selectedTraining={{
                                            ...selectedTraining,
                                            trnUI: selectedTraining.trainingnoUI
                                        }}
                                        setSelectedTraining={setSelectedTraining}
                                        trnOptions={trnData}
                                        isEdit={true}
                                        setIsEdit={setIsEdit}
                                        trnData={trnData}
                                    />
                                </SafeAreaView>
                            </SafeAreaView>
                        ) : (
                            <></>
                        )}

                    </SafeAreaView>
                </SafeAreaView>
            ) : (
                <></>
            )}

            {showAcademicQualifications ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:academicQual')}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminAcademicQualifications
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}

                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }
            {showEmployeeRates ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:rates')}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmployeeRates
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany?.code}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }
            {showAdditionalQualifications ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:additionalQual')}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminAdditionalQualifications
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}

                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }
            {showSpecialDocuments ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:specialDoc')}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmplSpecialDocuments
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }
            {showExitProcess ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t('navigate:exitProcess')}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmplExitProcess
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }
            {showEmplAlerts ?
                <SafeAreaView style={[styles.main]}>
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmpAlerts
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>}
            {showAdvancedSettings ?
                <SafeAreaView style={[styles.main]}>
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminAdvancedSettings
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>}

            {showProfessionalBodies && isAdmin ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={'Professional Bodies'}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmplProBodies
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }

            {showInventory && isAdmin ?
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={'Inventory'}
                        type='MINORTITLE'
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminEmplInventory
                            selectedEmployee={selectedEmployee}
                            selectedCompany={selectedCompany}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                : <></>
            }
        </SafeAreaView >
    )
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
    },
    subMain: {
        flex: 1,
        marginVertical: 10,
        marginHorizontal: 30,
    },
    mainSubTabs: {
        zIndex: 2000,
        flexDirection: "row",
        alignSelf: 'flex-start',
        marginBottom: '1%',
    },
    submain: {
        flex: 1,
        marginHorizontal: (Platform.OS === 'web' ? 10 : 5),
        backgroundColor: (Platform.OS === 'web' ? colors.background_card : colors.background),
        borderRadius: 35,
        elevation: (Platform.OS === 'web' ? 3 : 0),
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        shadowRadius: (Platform.OS === 'web' ? 5 : 0),
    },
    row: {
        flexDirection: "row",
    },
    backButton: {
        alignSelf: 'flex-start',
        margin: 10,
        marginBottom: 0
    },
});

export default HRAdminPageEmployees; 